import styles from "../../../styles";
import {Li} from "glamorous";
import React from "react";

const flexItem = styles.background.flexItem;

export default (props) => (
  <Li key={`flex_${props.index}`} css={flexItem} onClick={props.onClick}>
    {props.children}
  </Li>
);


// WEBPACK FOOTER //
// ./src/components/areas/Background/Item.js